// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-689ddf49] .el-table th>.cell{font-size:12px;font-weight:400}[data-v-689ddf49] .el-table th{padding:10px 0;line-height:16px}[data-v-689ddf49] .el-table .cell{font-size:12px;font-weight:400}[data-v-689ddf49] .el-table .cell span{font-size:12px}", ""]);
// Exports
module.exports = exports;
